import { render, staticRenderFns } from "./CommonTableByAgGrid.vue?vue&type=template&id=14d520c9&scoped=true&"
import script from "./CommonTableByAgGrid.vue?vue&type=script&lang=js&"
export * from "./CommonTableByAgGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d520c9",
  null
  
)

export default component.exports